<template>
  <div class="grid">
    <router-link
      style="grid-column: 2; grid-row: 2"
      :to="{ name: 'Stage', params: { id: 0 } }"
    >
      <img class="stage" :src="require(`@/assets/img/stages/grass.webp`)" />
    </router-link>
    <router-link
      style="grid-column: 3; grid-row: 2"
      :to="{ name: 'Stage', params: { id: 1 } }"
    >
      <img class="stage" :src="require(`@/assets/img/stages/bush.webp`)" />
    </router-link>
    <router-link
      style="grid-column: 2; grid-row: 1"
      :to="{ name: 'Stage', params: { id: 2 } }"
    >
      <img class="stage" :src="require(`@/assets/img/stages/forest.webp`)" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Stages",
};
</script>

<style scoped>
.grid {
  display: grid;
  justify-self: stretch;
}

.stage {
  width: 300px;
  height: 300px;
  image-rendering: pixelated;
  margin: 10px;
  transition: filter 0.1s;
  cursor: pointer;
}

.stage:hover {
  filter: brightness(110%);
}
</style>